<div *ngIf="enabled" class="d-flex">
  <button class="btn btn-link ms-auto" type="button" (contextmenu)="debug($event)"
    tooltip="{{isFavorite ? 'Dit artikel staat in de favorieten' : 'Klik hier om dit artikel toe te voegen aan de favorieten'}}"
    placement="left" container="body" (click)="toggleFavorite()">
    <span *ngIf="!isFavorite" class="text-low"><i class="far fa-star"></i></span>
    <span *ngIf="isFavorite" class="text-warning"><i class="fas fa-star"></i></span>
  </button>
</div>